import {QueryClient} from '@tanstack/react-query';

// Shared QueryClient instance for the entire application
// This allows services to invalidate queries when needed
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
            gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
            retry: 3,
            retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
            refetchOnWindowFocus: false,
        },
        mutations: {
            retry: 2,
            retryDelay: 1000,
        },
    },
});
